<template>
  <div>
    <EmdAddressBrazilianForm
      :searchZipCodeIsAllowed="canSearchZipCode"
      :value="recipient.address"
      :showSideBlock="showSideBlock"
    />
    <AddressReferencePointInput :recipient="recipient.address" />
  </div>
</template>
<script>
import { EmdAddressBrazilianForm } from 'emerald-vue/src/components'

import { AddressReferencePointInput } from './FormFields'
export default {
  name: 'AddressSection',
  components: {
    EmdAddressBrazilianForm,
    AddressReferencePointInput
  },
  props: {
    recipient: {
      type: Object,
      required: true
    },
    showSideBlock: {
      type: Boolean,
      default: true
    },
    canSearchZipCode: {
      type: Boolean,
      default: true
    }
  }
}
</script>
